// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"ItemSettings_dropdownMenu__wb6Z+"};